export const apiBaseUrl =
  import.meta.env.VITE_API_BASE_URL ??
  "https://call2app-ai-call-backend.yec.workers.dev";

export const webSessionStorageKey = "call2app_web_session";
